import React, { useState } from "react";
import styles from "./settingsAccountStatus.module.css";
import CloseAccountModal from "./closeAccountModal/CloseAccountModal";
import { Link } from "react-router-dom";
import axios from "axios";

const apiUrl = process.env.REACT_APP_URL;

const SettingsAccountStatus = ({ currUsername }) => {
  /* This component shows the user the account status, and allows the user to close the account. */

  const [showCloseAccountModal, setShowCloseAccountModal] = useState(false);
  const [accountClosed, setAccountClosed] = useState(false);
  const [actionFailed, setActionFailed] = useState(false);

  /**
   * Show the confirmation modal to allow the user to close the account
   */
  const handleCloseAccountClick = () => {
    setShowCloseAccountModal(true);
  };

  /**
   * Close the confirmation modal
   */
  const handleCloseModal = () => {
    setShowCloseAccountModal(false);
  };

  /**
   * Close the user account - change the account status to "closed", show confirmation, log out the user, and redirect him / her to the public home page.
   */
  const handleConfirmCloseAccount = async () => {
    setShowCloseAccountModal(false);

    try {
      const res = await axios.put(
        `${apiUrl}/users/close_account/${currUsername}`,
        {
          withCredentials: true,
        }
      );

      if (res.status === 200 && res.data.success) {
        setAccountClosed(true);
        setActionFailed(false);

        const logoutRes = await axios.post(`${apiUrl}/auth/logout`, {
          withCredentials: true,
        });

        if (logoutRes.status === 200 && logoutRes.data.success) {
          setTimeout(function () {
            window.location.href = "/";
          }, 2000);
        }
      } else {
        console.error("Error closing the user account.");
        setAccountClosed(false);
        setActionFailed(true);
      }
    } catch (error) {
      if (error.response && error.response.status === 401) {
        console.error("User is not logged in");
        setAccountClosed(false);
        setActionFailed(true);
      } else {
        console.error("Error closing the user account.", error);
        setAccountClosed(false);
        setActionFailed(true);
      }
    }
  };

  return (
    <div className={styles.accountStatus}>
      <p>Your account is currently active.</p>
      <p>To permanently close your account, click on the button below.</p>
      <button
        className={styles.closeAccountBtn}
        onClick={handleCloseAccountClick}
      >
        CLOSE ACCOUNT
      </button>
      <div className={styles.feedback}>
        {accountClosed && (
          <div className={styles.actionPositiveFeedback}>
            <p>Your account has been successfully closed.</p>
            <p>We wish you the best!</p>
            <p>You are being logged out . . .</p>
          </div>
        )}

        {!accountClosed && actionFailed && (
          <div className={styles.actionNegativeFeedback}>
            <p>We are unable to close your account at this time.</p>
            <p>
              Please try again later or <Link to="/acontact">contact us</Link>.
            </p>
          </div>
        )}
      </div>
      <div>
        <CloseAccountModal
          show={showCloseAccountModal}
          onClose={handleCloseModal}
          onConfirm={handleConfirmCloseAccount}
          accountUsername={currUsername}
        />
      </div>
    </div>
  );
};

export default SettingsAccountStatus;
